import React from 'react'
import { Link } from 'react-router-dom'

// Forwards its ref so it can be the `component` of a MUI ButtonBase or Button.
const AccountRouterLink = React.forwardRef(({ to, ...props }, ref) => {
  return (
    <Link
      ref={ref}
      to={`${to}?return_to=${encodeURIComponent(window.location.pathname)}`}
      {...props}
    />
  )
})

AccountRouterLink.displayName = 'AccountRouterLink'

export default AccountRouterLink
